var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftArrowGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_332_958",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 12,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5267 7.8332L5.08003 7.8332L8.33336 4.57987C8.59336 4.31987 8.59336 3.8932 8.33336 3.6332C8.07336 3.3732 7.65336 3.3732 7.39336 3.6332L3.00003 8.02653C2.74003 8.28653 2.74003 8.70653 3.00003 8.96653L7.38669 13.3665C7.51125 13.4914 7.68035 13.5615 7.85669 13.5615C8.03304 13.5615 8.20214 13.4914 8.32669 13.3665C8.58669 13.1065 8.58669 12.6865 8.32669 12.4265L5.08003 9.16653L12.5267 9.16653C12.8934 9.16653 13.1934 8.86653 13.1934 8.49987C13.1934 8.1332 12.8934 7.8332 12.5267 7.8332Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_332_958)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.5,
    width: 16,
    height: 16,
    transform: "rotate(-180 16 16.5)",
    fill: "white",
    fillOpacity: 0.64
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowGray);
export default __webpack_public_path__ + "static/media/LeftArrowGray.d03bb1de0e7b877833f20bea1ef3e1cf.svg";
export { ForwardRef as ReactComponent };